import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Statistics from "../pages/statistics/page";
import MyNumbers from "../pages/my-numbers/page";
import Login from "../pages/auth/login/page";
import Register from "../pages/auth/register/page";
import ResetPassword from "../pages/auth/reset-password/page";
import Account from "../pages/account/page";
import Admin from "../pages/admin/page";
import Guide from "../pages/guide/page";
import { AuthGuard, AdminGuard } from "../components/feature/AuthGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/statistics",
    element: <AuthGuard><Statistics /></AuthGuard>,
  },
  {
    path: "/my-numbers",
    element: <AuthGuard><MyNumbers /></AuthGuard>,
  },
  {
    path: "/guide",
    element: <Guide />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/account",
    element: <AuthGuard><Account /></AuthGuard>,
  },
  {
    path: "/admin",
    element: <AdminGuard><Admin /></AdminGuard>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;